/**
 * Wire shapes for message attachments — references only, never contents.
 * Mirrors `epi_study_agent/attachments.py`: snake_case out, camelCase on the echo.
 */
import { z } from 'zod';

import type { EpiAttachment } from '../types/epi-chat-types';

export const WireAttachmentSchema = z.object({
  file_id: z.string().min(1),
  filename: z.string().min(1),
  mime_type: z.string().min(1),
  size: z.number().int().nonnegative(),
});

export type WireAttachment = z.infer<typeof WireAttachmentSchema>;

/** Attachments as they arrive on the durable ``user_message`` echo (camelCase). */
export const EchoedAttachmentSchema = z.object({
  fileId: z.string().min(1),
  filename: z.string().min(1),
  mimeType: z.string().min(1),
  size: z.number().int().nonnegative(),
});

export const EchoedAttachmentsSchema = z.array(EchoedAttachmentSchema);

export const toWireAttachment = (attachment: EpiAttachment): WireAttachment => ({
  file_id: attachment.fileId,
  filename: attachment.filename,
  mime_type: attachment.mimeType,
  size: attachment.size,
});

/** Parse a durable echo's `attachments`. Malformed costs the cards, not the bubble. */
export const parseEchoedAttachments = (value: unknown): EpiAttachment[] => {
  if (value === undefined || value === null) return [];
  const parsed = EchoedAttachmentsSchema.safeParse(value);
  if (!parsed.success) {
    console.warn(
      '[epi-chat] dropping malformed attachments on user_message echo',
      parsed.error.issues
    );
    return [];
  }
  return parsed.data;
};
